import type { PatentBasicEntity, PatentValuationEntity } from '../types';

export const GetBasicByIdDTO = Symbol.for('GetBasicByIdDTO');

export interface GetBasicByIdDTO {
    getBasicById(patentId: string): Promise<PatentBasicEntity>;
}

export const GetValuationByIdDTO = Symbol.for('GetValuationByIdDTO');

export interface GetValuationByIdDTO {
    getValuationById(patentId: string): Promise<PatentValuationEntity>;
}
